import React from 'react';
import styled from 'styled-components';
import { MediaQueryWrap } from 'routes/_components/layout/MediaContextProvider';
import PackageCardSmallPlaceholder from 'components/packageCard/PackageCardSmallPlaceholder';
import flexbox from 'styles/utils/flexbox';

function Placeholder() {
  const medias = [
    {
      key: 'popular-items-placeholder-mobile',
      query: { lessThan: 'lg' },
      component: (
        <Container>
          <PackageCardSmallPlaceholder />
        </Container>
      ),
    },
    {
      key: 'popular-items-placeholder-large',
      query: { greaterThanOrEqual: 'lg' },
      component: (
        <Container>
          <PackageCardSmallPlaceholder />
          <PackageCardSmallPlaceholder />
          <PackageCardSmallPlaceholder />
        </Container>
      ),
    },
  ];

  return <MediaQueryWrap medias={medias} />;
}

export default Placeholder;

const Container = styled.div`
  ${flexbox({
    justifyContent: 'space-around',
  })}
`;
